// src/utils/toTrack.js – ensure both likeCount **and** likes keys exist so
// older UI code keeps working.
import {withPublicCatalogPreview} from "../lib/publicCatalogPreview";

export default function toTrack(docSnap) {
    const d = docSnap.data();
  
    // Normalise like counters – prefer 'likeCount' if it exists in Firestore,
    // otherwise fall back to a 'likes' field, defaulting to 0.
    const likeCount =
      typeof d.likeCount === "number"
        ? d.likeCount
        : typeof d.likes === "number"
        ? d.likes
        : 0;
  
    return withPublicCatalogPreview({
      ...d,
      id: docSnap.id,
      title: d.title || "Untitled",
      imageURL: d.imageURL || d.cover || "",
  
      // include *both* keys so legacy components render correctly
      likeCount,
      likes: likeCount,
  
      price: d.price ?? null,
      specialPrice: d.specialPrice ?? null,
      /* Catalog listeners always receive the tagged preview route. */
    });
  }
  
